<template>
  <div class="footer-area-wrapper" :class="FooterStyle">
    <div class="footer-area section-space--ptb_90">
      <div class="container">
        <div class="row footer-widget-wrapper">
          <div class="col-lg-12 col-md-12 footer-widget">
            <div class="footer-widget__logo mb-30">
              <router-link to="/">
                <img
                  src="https://html-templates-ses-yoursynchronicity.s3-eu-west-1.amazonaws.com/public-assets/yoursynchronicity.png"
                  class="img-fluid logo-dark" alt="">

              </router-link>
            </div>
            <!--            <ul class="footer-widget__list">-->
            <!--              &lt;!&ndash;              <li>58 Howard Street #2 San Francisco, CA 941</li>&ndash;&gt;-->
            <!--              <li><a href="#" class="hover-style-link">contact@yoursynchronicity.com</a></li>-->
            <!--              &lt;!&ndash;              <li><a href="#" class="hover-style-link">(+68)1221 09876</a></li>&ndash;&gt;-->
            <!--              <li><a href="https://www.yoursynchronicity.com"-->
            <!--                     class="hover-style-link hover-style-link&#45;&#45;green">www.yoursynchronicity.com</a>-->
            <!--              </li>-->
            <!--            </ul>-->
          </div>
          <!--                    <div class="col-lg-2 col-md-6 footer-widget">-->
          <!--                      <h6 class="footer-widget__title mb-20">Who we are</h6>-->
          <!--                      <ul class="footer-widget__list">-->
          <!--                        <li><a href="#" class="hover-style-link">About us</a></li>-->
          <!--                        <li><a href="#" class="hover-style-link">Before you go</a></li>-->
          <!--                        <li><a href="#" class="hover-style-link">Online check in</a></li>-->
          <!--                        <li><a href="#" class="hover-style-link">FAQ</a></li>-->
          <!--                      </ul>-->
          <!--                    </div>-->
          <div class="col-lg-2 col-md-6 footer-widget">
            <h6 class="footer-widget__title mb-20">Quick links</h6>
            <ul class="footer-widget__list">
              <li><a href="https://www.yoursynchronicity.com/terms" class="hover-style-link">Terms</a></li>
              <li><a href="https://www.yoursynchronicity.com/privacy" class="hover-style-link">Privacy Policy</a></li>
            </ul>
          </div>
          <!--                    <div class="col-lg-3 col-md-6 offset-lg-1 footer-widget">-->
          <!--                      <div class="twitter-feed-slider">-->
          <!--                        <div class="swiper-container twitter-feed-slider__container">-->
          <!--                          <div class="swiper-wrapper twitter-feed-slider__wrapper">-->
          <!--                            <div class="swiper-slide twitter-feed-slider__single">-->
          <!--                              <div class="tweet">-->
          <!--                                <div class="tweet__text">-->
          <!--                                  "The ocean never ceases to amaze!" Feature: Ben Klea-->
          <!--                                  <a href="https://t.co/jSRMsZAdPW"-->
          <!--                                     target="_blank">https://t.co/jSRMsZAdPW</a>-->
          <!--                                  <a href="https://t.co/2iDReuyPMt"-->
          <!--                                     target="_blank">https://t.co/2iDReuyPMt</a>-->
          <!--                                </div>-->
          <!--                                <div class="tweet__info">-->
          <!--                                  <h6 class="tweet__heading">Unsplash</h6>-->
          <!--                                  <span class="tweet__date">May 07, 2019</span>-->
          <!--                                </div>-->
          <!--                              </div>-->
          <!--                            </div>-->
          <!--                          </div>-->
          <!--                        </div>-->
          <!--                      </div>-->
          <!--                    </div>-->
        </div>
      </div>
    </div>
    <div class="footer-copyright-area border-top section-space--ptb_30">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 text-center text-md-left">
            <span class="copyright-text">© 2020 YourSynchronicity. All Rights Reserved.</span>
          </div>
          <div class="col-md-6 text-center text-md-right">
            <ul class="list ht-social-networks solid-rounded-icon">
              <li class="item">
                <a href="#" target="_blank" class="social-link"> <i
                  class="fab fa-facebook social-link-icon"></i> </a>
              </li>
              <li class="item">
                <a href="#" target="_blank" class="social-link"> <i
                  class="fab fa-twitter social-link-icon"></i> </a>
              </li>
              <li class="item">
                <a href="#" target="_blank" class="social-link"> <i
                  class="fab fa-instagram social-link-icon"></i> </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'FooterMain',
        props: ["FooterStyle"]
    }
</script>
